export default function ProcessSection() {
  const steps = [
    {
      number: "01",
      title: "Property Analysis",
      description: "We analyze your investment property's rental income potential and cash flow to determine DSCR eligibility.",
      icon: "ri-search-line"
    },
    {
      number: "02",
      title: "Application Submission",
      description: "Submit your streamlined application with property details and rental income documentation.",
      icon: "ri-file-list-line"
    },
    {
      number: "03",
      title: "Quick Approval",
      description: "Receive fast approval based on property performance, not personal income verification.",
      icon: "ri-checkbox-circle-line"
    },
    {
      number: "04",
      title: "Funding & Closing",
      description: "Close quickly and get funded to start or expand your investment property portfolio.",
      icon: "ri-funds-line"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gradient-to-br from-blue-500/20 to-emerald-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-gradient-to-br from-emerald-500/20 to-blue-500/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm text-white rounded-full text-sm font-semibold mb-8 shadow-lg border border-white/20">
            <i className="ri-route-line mr-2"></i>
            Simple Process
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            How DSCR Financing Works
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Our streamlined process makes it easy to secure financing for your investment property in just four simple steps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-emerald-500/50 to-blue-500/50 transform translate-x-0 z-0"></div>
              )}
              
              <div className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-300 h-full">
                {/* Step number */}
                <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-white font-bold text-sm">{step.number}</span>
                </div>

                {/* Icon */}
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-xl flex items-center justify-center mb-6 shadow-lg group-hover:shadow-xl transform group-hover:scale-110 transition-all duration-300">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-white/70 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center px-6 py-4 bg-white/10 backdrop-blur-sm rounded-xl border border-white/20">
            <i className="ri-time-line text-emerald-400 text-2xl mr-3"></i>
            <span className="text-white font-semibold">Typical timeline: 2-4 weeks from application to funding</span>
          </div>
        </div>
      </div>
    </section>
  );
}
